var Student = "Étudiant";
var jobRole = {
	"Job role": "Fonction",
	"Academic / Researcher": "Universitaire/chercheur",
	"Advisor / Consultant": "Conseiller/consultant",
	"Business Executive": "Dirigeant d'entreprise",
	"Developer / Engineer": "Développeur/ingénieur",
	"Entrepreneur (Founder/Co-Founder)": "Entrepreneur (fondateur/co-fondateur)",
	"IT Executive": "Cadre informatique",
	"IT Professional or Technical Manager": "Expert informatique ou responsable technique",
	"Press / Media Analyst": "Presse/analyste des médias",
	"Sales / Marketing": "Ventes/marketing",
	Student: Student,
	"Solution or Systems Architect": "Architecte de solutions ou systèmes",
	"System Administrator": "Administrateur système",
	"Venture Capitalist": "Investisseur en capital-risque"
};

export { Student, jobRole as default };
